module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "qtt-msg-box"
  }, [_c('div', {
    staticClass: "qtt-msg-panel"
  }, [_c('header', [_c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        return _vm.closePanel('cancel')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qtt-msg-content"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.content),
      expression: "content"
    }]
  }, [_vm._v(_vm._s(_vm.content))])]), _vm._v(" "), _c('div', {
    staticClass: "qtt-message-action"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.closePanel('sure')
      }
    }
  }, [_vm._v("确定 " + _vm._s(_vm.shortCut ? '(空格)' : ''))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.closePanel('cancel')
      }
    }
  }, [_vm._v("取消 " + _vm._s(_vm.shortCut ? 'Esc' : ''))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bf0e06a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/widget/MessageBoxOwn.vue
// module id = 643
// module chunks = 25